

<template>
  <div class="form-init">
    
    <div>
      <div class="tabs">
        <router-link
          to="/cuotas-y-minimos"
          class="nav-link"
          active-class="is-active"
          exact
        >
          Cápita mímina opciones
        </router-link>
        <router-link
          to="/monotributo"
          class="nav-link"
          active-class="is-active"
          exact
        >
          ACM Monotributistas
        </router-link>
         <router-link
          to="/adherentes"
          class="nav-link"
          active-class="is-active"
          exact
        >
          Adherentes
        </router-link>
        <!--
         <router-link
          to="/Localidades"
          class="nav-link"
          active-class="is-active"
          exact
        >
          Zonas/Localidades
        </router-link>
        -->
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>


export default {
  name: "PlansPage",
  data() {
    return {
      currentYear: null,
      currentMonth: null
    };
  },
  created() {
    this.setCurrentDate();
  },
  methods: {
     setCurrentDate() {
      const currentDate = new Date();
      this.currentYear = currentDate.getFullYear();
       const monthName = currentDate.toLocaleString('default', { month: 'long' });
      this.currentMonth = monthName.charAt(0).toUpperCase() + monthName.slice(1); //
      
    }
  }
};
</script>

<style scoped>
.title-container {
  display: flex;
  justify-content: flex-end;
}
.tabs {
  display: flex;
  justify-content: left;
  align-items: left;
}

.nav-link {
  padding: 10px;
  margin-right: 10px;
  border-bottom: none;
}

.nav-link:hover,
.nav-link.is-active {
  background-color: transparent;
  border-color: transparent;
  color: #00758f;
  border-bottom: 3px solid #00758f;
}
.form-init {
  position: relative;
  top: -15vh;
  background: white;
  max-width: 83%;
  padding: 40px 30px;
  margin: 0 auto;
}
h1.title {
  font-weight: bold;
  font-size: 24px;
  color: #00758f;
  line-height: 1.9rem;
}
button {
  width: 195px;
  max-width: 195px !important;
  margin-left: auto !important;
  background: #00758f;
  color: #fff;
  font-size: 24px;
  color: #ffffff;
  display: block;
  text-transform: uppercase;
  border-radius: 0;
}
button:hover {
  width: 195px;
  font-weight: bold;
  color: #fff;
}
@media screen and (max-width: 480px) {
  .form-init {
    position: relative;
    top: -20px;
    padding: 40px 20px;
    margin: 0 auto;
  }
  .title {
    font-size: 20px !important;
    text-align: center;
    margin-bottom: 30px;
  }
  .title br {
    display: none;
  }
  .title .hola {
    display: block;
    font-size: 50px;
    margin-bottom: 20px;
  }
  .title .queres {
    display: block;
    margin-bottom: 20px;
  }
  .button {
    margin: 0 auto;
    max-width: 100% !important;
    width: 100% !important;
  }
}

.input-ul {
  padding: 0;
  margin: 0;
  list-style: none;
  width: 100%;
  margin-bottom: 10px;
}
.input-ul li {
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
}
.input-ul li:last-child {
  margin-right: 0;
}

input {
  background-color: transparent;
  /* width: initial!important; */
}

select,
input[type="text"],
input[type="email"],
input[type="number"] {
  border-radius: 0;
  border: 0;
  border-bottom: 3px solid #fbaf33;
  font-size: 17px !important;

}

.input-ul li:first-child,
.input-ul li:last-child {
  font-size: 24px;
  color: #00758f;
}

/* SQUARED ONE */
.squaredOne {
  width: 28px;
  height: 28px;
  background: #fcfff4;
  margin: 20px auto;
  position: relative;
}

.squaredOne label {
  cursor: pointer;
  position: absolute;
  width: 20px;
  height: 20px;
  left: 0;
  top: 0;
  border: 3px solid #fbaf33;
}

.squaredOne label:after {
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  filter: alpha(opacity=0);
  opacity: 0;
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  background: #fbaf33;
  top: 3px;
  left: 2px;
}

.squaredOne label:hover::after {
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=30)";
  filter: alpha(opacity=30);
  opacity: 0.3;
}

.squaredOne input[type="checkbox"]:checked + label:after {
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
  filter: alpha(opacity=100);
  opacity: 1;
}

.text {
  font-weight: bold;
  font-size: 24px;
  color: #00758f;
  line-height: 1.9rem;
}
@media screen and (max-width: 480px) {
  .text {
    font-size: 20px;
    font-weight: normal;
  }
 
  input[type="text"] {
    width: 180px !important;
  }
  select {
    width: 90% !important;
    border-radius: 0;
    border: 0;
    background: transparent;
    border-bottom: 3px solid #fbaf33;

  }
}


</style>
